module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic6.103524a4.png";